import { Box, styled } from '@mui/material'

const Container = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}))

export default Container
